import { GET_HIRING } from '../actions/Types'
const getHiringEmployeeCategory = (state=[], action) => {
    if (action.type === GET_HIRING){
        return action.payload
    }
    return state
}

export default getHiringEmployeeCategory